// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + (chunkId === 945 ? "dashboard" : chunkId) + "." + {"611":"0e51795b","647":"3d823687","706":"b58c0935","868":"9b275e59","945":"c05efb32"}[chunkId] + ".css";
};